import * as angular from "angular";
import {IHttpService, IQService} from "angular";
import {SplitService} from "../../commons/services/split-service.service";
import {ApiConfig} from "../../commons/models/api-config.model";
import {RoutesListPayloadModel} from "../models/routes-list-payload.model";
import {
  EditDispatchedRouteNameRequestModel
} from "../models/edit-dispatched-route-name-request.model";
import {ResourceAllocationTimeWindowExtModel} from "../../resources/models/resource-allocation-time-window-ext.model";
import {ChangeRouteResourceQueryModelModel} from "../models/change-route-resource-query-model.model";
import {GetRouteIdsByQueryPayloadModel} from "../models/get-route-ids-by-query-payload.model";

export class RouteRequestsService {
  constructor(private $route, private RoutesAPI, private $q: IQService,
              private apiConfig: ApiConfig, private $http: IHttpService,
              private splitService: SplitService) {
  }

  // ******************************
  // External methods
  // ******************************

  getRouteIdsByQuery(queries: GetRouteIdsByQueryPayloadModel) {
    const api = this.RoutesAPI.actions.getRouteIdsByQuery;
    return this.$$call(api, queries, {}, {});
  }

  updateRoute(route) {
    const api = this.RoutesAPI.actions.updateRoute;
    return this.$$call(api, {}, route, {routeId: route.id});
  }

  getRouteTasksData(payload) {
    const api = this.RoutesAPI.actions.getRouteTasksData;
    return this.$$call(api, {}, payload, {});
  }

  getRoutesBySyncIds(syncIds, expanded) {
    const api = this.RoutesAPI.actions.getRoutesBySyncIds;
    return this.$$call(api, {syncIds: syncIds, expanded: expanded}, {}, {});
  }

  getRoutesList(query: RoutesListPayloadModel) {
    const api = this.RoutesAPI.actions.getRoutesList;
    return this.$$call(api, query, {}, {});
  }

  getSuggestedDeliveries(routeId) {
    const deferred = this.$q.defer(),
      api = this.RoutesAPI.actions.getSuggestedDeliveries;

    this.$$call(api, {}, {}, {routeId: routeId}).then(
      (deliveries) => {
        //TODO add persistence handling.
        deferred.resolve(deliveries);
      },
      deferred.reject
    );

    return deferred.promise;
  }

  generateRoutes(data) {
    const api = this.RoutesAPI.actions.generateRoutes;
    return this.$$call(api, {}, data, {});
  }

  addDeliveriesToRoute(deliveryIds, routeId) {
    const api = this.RoutesAPI.actions.putDelivery;
    return this.$$$call(api, {deliveryIds: deliveryIds}, {}, {}, routeId);
  }

  removeDeliveryFromRoute(deliveryIds, routeId) {
    const api = this.RoutesAPI.actions.removeDelivery;
    return this.$$$call(api, {deliveryIds: deliveryIds}, {}, {}, routeId);
  }

  getRoutesByIds(ids) {
    const api = this.RoutesAPI.actions.getRoutes;
    return this.$$call(api, {}, {}, {ids: ids})
  }

  getRoutes(from, to) {
    const api = this.RoutesAPI.actions.getRoutes;
    return this.$$call(api, {}, {}, {from: from, to: to})
  }

  assignRouteToAgent(routeId, agentId, doForce) {
    const api = this.RoutesAPI.actions.assign;
    return this.$$call(api, {force: doForce}, {}, {routeId: routeId, agentId: agentId})
  }

  assignAssistant(routeId, assistantIdList: string[]) {
    const api = this.RoutesAPI.actions.assignAssistant;
    return this.$$call(api, {}, assistantIdList, {routeId: routeId})
  }

  assignAssistants(routeIds: string[], assistantIdList: string[]) {
    const api = this.RoutesAPI.actions.assignAssistants;
    return this.$$call(api, {}, {
      routeIds: routeIds,
      assistantIds: assistantIdList
    }, {})
  }

  assignLogisticVehicles(routeIds: string[], mainLogisticVehicleId?: string, attachedLogisticVehicleIds?: string[]) {
    const api = this.RoutesAPI.actions.assignLogisticVehicles;
    return this.$$call(api, {}, {
      routeIds: routeIds,
      mainLogisticVehicleId: mainLogisticVehicleId,
      attachedLogisticVehicleIds: attachedLogisticVehicleIds
    }, {})
  }

  // DEPRECATED
  // changeRouteResource(routeId: string, destinationResource, queries?: ChangeRouteResourceQueryModelModel) {
  //   const api = this.RoutesAPI.actions.changeRouteResource;
  //   if (!queries) {
  //     queries = {};
  //   }
  //   return this.$$call(api, queries, destinationResource, {routeId: routeId})
  // }

  deleteRoutes(ids?, branchIds?, excludedIds?, from?, to?, agentSkills?: string[], query?: string, areaIds?: string[], statuses?: string[],
               resourceIds?: string[], tags?: string[], depotIds?: string[], resourceTags?: string[], vehicleTypeIds?: string[], relationTypes?: string[]) {
    const api = this.RoutesAPI.actions.deleteRoutes;
    return this.$$call(api, {
      ids: ids,
      branchIds: branchIds,
      depotIds: depotIds,
      excludedIds: excludedIds,
      from: from,
      to: to,
      skills: agentSkills,
      query: query,
      areaIds: areaIds,
      status: statuses,
      resourceIds: resourceIds,
      tags: tags,
      resourceTags: resourceTags,
      vehicleTypeIds: vehicleTypeIds,
      relationTypes: relationTypes
    }, {}, {})
  }

  resetRoutes(ids?, branchIds?, excludedIds?, from?, to?, resetOnlyAssignAgentServices?, agentSkills?: string[], query?: string, areaIds?: string[], statuses?: string[],
              resourceIds?: string[], tags?: string[], depotIds?: string[], resourceTags?: string[], vehicleTypeIds?: string[], relationTypes?: string[]) {
    const api = this.RoutesAPI.actions.resetRoutes;
    return this.$$call(api, {
      ids: ids,
      branchIds: branchIds,
      depotIds: depotIds,
      excludedIds: excludedIds,
      from: from,
      to: to,
      considerRoutesAgent: resetOnlyAssignAgentServices,
      skills: agentSkills,
      query: query,
      areaIds: areaIds,
      status: statuses,
      resourceIds: resourceIds,
      tags: tags,
      resourceTags: resourceTags,
      vehicleTypeIds: vehicleTypeIds,
      relationTypes: relationTypes
    }, {}, {})
  }

  updateBranch(ids, branchIdsPayload, branchIds?, excludedIds?, from?, to?, agentSkills?: string[], query?: string, areaIds?: string[], statuses?: string[],
               resourceIds?: string[], tags?: string[], depotIds?: string[], resourceTags?: string[], vehicleTypeIds?: string[], relationTypes?: string[]) {
    const api = this.RoutesAPI.actions.updateBranch;
    return this.$$call(api, {
      ids: ids,
      branchIds: branchIds,
      depotIds: depotIds,
      excludedIds: excludedIds,
      from: from,
      to: to,
      skills: agentSkills,
      query: query,
      areaIds: areaIds,
      status: statuses,
      resourceIds: resourceIds,
      tags: tags,
      resourceTags: resourceTags,
      vehicleTypeIds: vehicleTypeIds,
      relationTypes: relationTypes
    }, {branchIds: branchIdsPayload}, {})
  }

  associateAgent(routeIds: string[], agentId: string, branchIds?: string[], excludedIds?: string[], from?: number, to?: number, agentSkills?: string[], query?: string, areaIds?: string[], statuses?: string[],
               resourceIds?: string[], tags?: string[], depotIds?: string[]) {
    const api = this.RoutesAPI.actions.associateAgent;
    return this.$$call(api, {
      ids: routeIds,
      branchIds: branchIds,
      depotIds: depotIds,
      excludedIds: excludedIds,
      from: from,
      to: to,
      skills: agentSkills,
      query: query,
      areaIds: areaIds,
      status: statuses,
      resourceIds: resourceIds,
      tags: tags
    }, {agentId: agentId, branchIds: branchIds}, {})
  }

  mergeRoutes(ids, branchIds?, excludedIds?, from?, to?, agentSkills?: string[], query?: string, areaIds?: string[], statuses?: string[],
              resourceIds?: string[], tags?: string[], depotIds?: string[], resourceTags?: string[], vehicleTypeIds?: string[], relationTypes?: string[]) {
    const api = this.RoutesAPI.actions.mergeRoutes;
    return this.$$call(api, {
      ids: ids,
      branchIds: branchIds,
      excludedIds: excludedIds,
      from: from,
      to: to,
      skill: agentSkills,
      query: query,
      areaIds: areaIds,
      status: statuses,
      resourceIds: resourceIds,
      tags: tags,
      resourceTags: resourceTags,
      vehicleTypeIds: vehicleTypeIds,
      relationTypes: relationTypes
    }, {}, {})
  }

  assignRoutesToAttachedAgents(ids, branchIds?, excludedIds?, from?, to?, agentSkills?: string[], query?: string, areaIds?: string[], statuses?: string[],
                               resourceIds?: string[], tags?: string[], depotIds?: string[], resourceTags?: string[], vehicleTypeIds?: string[], relationTypes?: string[]) {
    const api = this.RoutesAPI.actions.assignRoutesToAttachedAgents;
    return this.$$call(api, {
      ids: ids,
      branchIds: branchIds,
      depotIds: depotIds,
      excludedIds: excludedIds,
      from: from,
      to: to,
      skills: agentSkills,
      query: query,
      areaIds: areaIds,
      status: statuses,
      resourceIds: resourceIds,
      tags: tags,
      resourceTags: resourceTags,
      vehicleTypeIds: vehicleTypeIds,
      relationTypes: relationTypes
    }, {}, {})
  }

  editRouteName(routeId: String, payload: EditDispatchedRouteNameRequestModel) {
    const api = this.RoutesAPI.actions.setName;
    return this.$$call(api, {}, payload, {routeId: routeId});
  }

  addRouteMetadata(routeId: string, metaData: { key: string, value: string }[]) {
    const api = this.RoutesAPI.actions.addRouteMetadata;
    return this.$$call(api, {}, metaData, {routeId: routeId});
  }

  getRoutesStatusesTotals(ids, from, to, branchIds, areaIds, query, tags, agentIds?: string[], agentSkills?: string[], resourceIds?: string[], statuses?: string[], depotIds?: string[], resourceTags?: string[], vehicleTypeIds?: string[], relationTypes?: string[]) {
    const api = this.RoutesAPI.actions.getRoutesStatusesTotals;
    return this.$$call(api, {
      ids: ids,
      from: from,
      to: to,
      branchIds: branchIds,
      depotIds: depotIds,
      areaIds: areaIds,
      query: query,
      tags: tags,
      resourceTags: resourceTags,
      agentIds: agentIds,
      skill: agentSkills,
      allocationIds: resourceIds,
      status: statuses,
      vehicleTypeIds: vehicleTypeIds,
      relationTypes: relationTypes
    }, {}, {})
  }

  updateTaskTimeWindow(routeId, id, payload) {
    const api = this.RoutesAPI.actions.updateTaskTimeWindow;
    return this.$$call(api, {}, payload, {taskId: id, routeId: routeId});
  }

  getLogsTimeline(routeId, limit: number) {
    const api = this.RoutesAPI.actions.getLogsTimeline;
    return this.$$call(api, {limit: limit}, {}, {routeId: routeId});
  }

  getPDFBolByRoutesIds(routesIds) {
    const url = this.apiConfig.baseUrl + `/routes/billoflading`;
    return this.$http.get(url, {
      params: {
        siteId: this.splitService.getSiteId(),
        ids: routesIds
      },
      responseType: "arraybuffer"
    })
  }


  // ******************************
  // Internal methods
  // ******************************

  private $$call(apiCall, params, data, options) {
    return this.$route().$call(apiCall, params, data, options);
  }

  private $$$call(apiCall, params, data, options, routeId) {
    return this.$route(routeId).$call(apiCall, params, data, options);
  }
}

angular
  .module('bringoz.admin.routes')
  .service('routeRequestsService', RouteRequestsService);

